// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "public/" + chunkId + "-" + {"132":"8ff916985f60d0210783","561":"5ff75646804d2e21f440","583":"491044d00af315d754de","611":"108a7e7993bc37aaeb29","906":"921e605bd1f8b55ddc03"}[chunkId] + ".js";
};